import { useDispatch } from "react-redux"
import {
   getFilesAndFoldersLoading,
   getFilesAndFoldersSuccess,
   getFilesAndFoldersFailure,
} from "src/redux/slices/filesAndFoldersSlice"
// import { getFilesAndFolders } from "src/services/getFilesAndFolders"
import { getSyncedFolderIds, getFoldersFromGoogleDrive } from "src/services/ml/getSyncedFolderIds"
import { syncAndProcessFolder, getFolderSyncAndProcessStatus, getMultipleJobsStatus } from "src/services/ml/syncAndProcessFolder"

const useFilesAndFolders = () => {

   const dispatch = useDispatch()
   
   const handleGetFilesAndFolders = async (googleDriveLink) => {
      try {
         dispatch(getFilesAndFoldersLoading())
         const response = await getFoldersFromGoogleDrive(googleDriveLink)
         // console.log(response.data)
         dispatch(getFilesAndFoldersSuccess(response.data))
      } catch (error) {
         dispatch(getFilesAndFoldersFailure())
         console.log(error)
      }
   }

   const handleGetSyncedFolderIds = async (userId) => {
      try {
         const data = { "user_id": userId }
         const response = await getSyncedFolderIds(data)
         return response.data
      } catch (error) {
         console.log("get synced folder ids error")
         console.log(error)
      }
   }

   const handleSyncAndProcessFolder = async (folderId, userId, adAccountId) => {
      try {
         const data = { "user_id": userId, "folder_id": folderId, "ad_account_id": adAccountId }
         const response = await syncAndProcessFolder(data)
         // console.log(response.data)
         return response.data
      } catch (error) {
         console.log("Sync and process folder error")
         console.log(error)
      }
   }

   const handleGetFolderSyncAndProcessStatus = async (jobId) => {
      try {
         const response = await getFolderSyncAndProcessStatus(jobId)
         // console.log(response)
         return response.data.status
      } catch (error) {
         console.log("Get folder sync and process status error")
         console.log(error)
      }
   }

   const handleGetFolderSyncAndProcessMultipleJobsStatus = async (jobIds) => {
      try {
         const response = await getMultipleJobsStatus(jobIds)
         // console.log(response)
         return response.data
      } catch (error) {
         console.log("Get folder sync and process multiple jobs status error")
         console.log(error)
      }
   }
   return { 
      handleGetFilesAndFolders, 
      handleGetSyncedFolderIds, 
      handleSyncAndProcessFolder, 
      handleGetFolderSyncAndProcessStatus,
      handleGetFolderSyncAndProcessMultipleJobsStatus 
   }
}

export default useFilesAndFolders 
